import { type AnyAction, type Dispatch, type MiddlewareAPI } from '@reduxjs/toolkit';
import { SessionStorageField } from 'types';
import { setSessionStorageItem } from 'utils/setSessionStorageItem';

const saveApplicationDataMiddleware =
  ({ getState }: MiddlewareAPI) =>
  (next: Dispatch) =>
  (action: AnyAction) => {
    const result = next(action);

    setSessionStorageItem(SessionStorageField.AppState, JSON.stringify(getState()));

    return result;
  };

export default saveApplicationDataMiddleware;
